module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HQUmEB/tc-custom/9781504073097.jpg?1723836043038",
      "alt": "This image is the cover for the book Whiskey Tango Foxtrot, The Constable Mavis Upton Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Whiskey Tango Foxtrot, The Constable Mavis Upton Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("For Mavis Upton, there’s a fine (blue) line between being a parent and a police officer in this sequel to "), _c('i', [_vm._v("Handcuffs, Truncheon and a Polyester Thong")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Our hapless heroine Constable Mavis Upton is preparing to step down the aisle with her fiancé Joe, but has to deal with her temperamental teen daughter, as well as investigate a serial flasher on a push bike. Throw a diva drag queen into the mix and readers can expect the usual hilarious Mavis mishaps that made the first book such a hit."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Revel in Gina Kirkham’s humorous, poignant and moving stories of an everyday woman who one day followed a dream."), _c('br'), _vm._v(" "), _c('br'), _c('b', [_vm._v("Series praise")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Laugh out loud brilliance, so witty and cleverly written.” —Samantha Magson"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Hilarious! It’s true, everyone needs Mavis in their life.” —Sherrie Hewson"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Such a terrific read!” —Lorraine Kelly\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gina Kirkham\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0